












































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts';
import Loading from '@/shared/loading/loading.component.vue';
import CandidateResult from '@/domain/selective-process/entity/candidate/candidate-result.entity';
import SelectiveProcessService from '@/domain/selective-process/service/selective-process.service';
import ErrorComponent from '@/shared/error/error.component.vue';
import CardTitle from '@/shared/card/card-title.component.vue';
import Candidate from '@/domain/selective-process/entity/candidate/candidate.entity';
import CandidateAssessment from '@/domain/selective-process/entity/assessment/assessment.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import CopyClipboardService from '@/shared/utils/copy-clipboard.service';
import AuthorityStore from '@/domain/security/authority.store';
import AuthorityEnum from '@/domain/security/authority.enum';
import PersonalityResultComponent from '../components/personality-result.component.vue';
import ReasoningResultComponent from '../components/reasoning-result.component.vue';
import FitCulturalComponent from '../components/fit-cultural-result.component.vue';
import JobListComponent from '../components/jobs-list.component.vue';
import ResetHistoryModal from '../modal/reset-history-modal.component.vue';

@Component({
  components: {
    VueApexCharts,
    ErrorComponent,
    Loading,
    CardTitle,
    PersonalityResultComponent,
    ReasoningResultComponent,
    FitCulturalComponent,
    JobListComponent,
    LabelSlot,
    ResetHistoryModal,
  },
})
export default class CandidateResultDetails extends Vue {
  @Prop({
    type: String,
  }) candidateId!: string;

  candidateResult: CandidateResult = new CandidateResult();

  candidate: Candidate = new Candidate();

  personalityFetchErrorMessage: string = '';

  loading: boolean = false;

  currentCandidateAssessment: CandidateAssessment = new CandidateAssessment();

  currentTab: string = 'reasoning';

  tabs: any[] = [
    { title: 'Teste de Raciocínio', value: 'reasoning' },
    { title: 'Fit Cultural', value: 'culture' },
    { title: 'Teste de Personalidade', value: 'personality' },
    { title: 'Vagas', value: 'jobs' },
  ];

  hasResetSurveyAuthorization: boolean = false;

  hasReadResetHistoryAuthorization: boolean = false;

  showResetHistoryModal: boolean = false;

  created() {
    this.getCandidateDetails()
    this.verifyAuthorities();
  }

  async getCandidateDetails() {
    this.loading = true;
    await SelectiveProcessService.getCandidateById(this.candidateId)
      .then((data) => {
        this.candidate = data;
        const currentCandidateAssessment = this.candidate.assessments[0];
        this.currentCandidateAssessment = currentCandidateAssessment;
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
      }).finally(() => {
        this.loading = false;
      });
  }

  async verifyAuthorities() {
    this.hasResetSurveyAuthorization = await AuthorityStore
      .hasAuthority([AuthorityEnum.RESET_SURVEY_ANSWER])
    this.hasReadResetHistoryAuthorization = await AuthorityStore
      .hasAuthority([AuthorityEnum.READ_RESET_CANDIDATE_SURVEY_HISTORY])
  }

  currentAssessmentText(candidateAssessment: CandidateAssessment): string {
    const startDate = moment(candidateAssessment.startDate).format('DD/MM/YYYY');
    if (this.candidate.assessments[0].id === candidateAssessment.id) {
      return `Teste atual (${startDate})`;
    }
    return `Teste anterior (${startDate})`;
  }

  copyToClipboard(text: string): void {
    CopyClipboardService.copyToClipboard(text);
  }

  goBack(): void {
    this.$router.go(-1);
  }

  getClosedDateFormat(date: string): string {
    return date ? moment(date).format('DD/MM/YYYY HH:mm') : '-';
  }

  handleSelectAssessment(assessment: CandidateAssessment): void {
    this.currentCandidateAssessment = assessment;
  }

  openResetHistoryModal() {
    this.showResetHistoryModal = true;
  }
}
